import { useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import PropTypes from "prop-types";
import { Link, NavLink } from "react-router-dom";

function DynamicTabs({ tabs }) {
  const location = useLocation();

  if (!tabs || tabs.length === 0) return null;

  if (tabs.length === 1) {
    return (
      <div className="w-100">
        <h5 className="mb-0">{tabs[0].name}</h5>
      </div>
    );
  }

  const activeTab = tabs.find(
    (tab) =>
      location.pathname === tab.href ||
      location.pathname.startsWith(tab.href + "/"),
  );

  return (
    <Nav
      fill
      variant="tabs"
      activeKey={activeTab?.href}
      className="w-100 nav-tabs"
    >
      {tabs.map((tab, index) => (
        <Nav.Item key={index}>
          <Nav.Link
            as={NavLink}
            to={tab.href}
            end
            className={({ isActive }) =>
              "dinamicNav " + (isActive ? "active" : "")
            }
          >
            {tab.name}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}

DynamicTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
};

export default DynamicTabs;
